import { Card, CardBody, Col } from "reactstrap";
import CommonCardFooter from "../Common/CommonCardFooter";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { VerticalStyles } from "../../../../Constant";
import { VERTICAL_STYLE } from "../../../../Data/FormControl/MegaOptions";
import VerticalStyleForm from "./VerticalStyleForm";

const VerticalStyle = () => {
  return (
    <Col sm="12" xxl="6" className="box-col-12">
      <Card className="height-equal">
        <CommonCardHeader title={VerticalStyles} span={VERTICAL_STYLE} />
        <CardBody>
          <VerticalStyleForm />
        </CardBody>
        <CommonCardFooter footerClass="text-end" color1="primary" color2="light" />
      </Card>
    </Col>
  )
};

export default VerticalStyle;
